const STATES = {
    MINI: 'LEARNING_ENGAGEMENT_MINI',
    FULL: 'LEARNING_ENGAGEMENT_FULL'
};

class HeuristicsEditorController {
    constructor(heuristicsService, $mdDialog) {
        let self = this;
        self.STATES = STATES;

        this.getAspects = () => {
            heuristicsService.getAllAspects().then((data) => {
                console.log(self.state);
                self.aspects = data;
                if (self.currentAspect) {
                    self.currentAspect = self.aspects.find(x => x.name === self.currentAspect.name);
                } else if (self.curraspectname) {
                    self.currentAspect = self.aspects.find(x => x.name === self.curraspectname);
                }
            });
        };

        this.selectAspect = (aspect) => {
            self.currentAspect = aspect;
            self.app = null;
        };

        this.saveAspect = (aspectDef) => {
            aspectDef = {...aspectDef};
            if (!aspectDef.definition) {
                aspectDef.definition = " ";
            }
            heuristicsService.updateAspectDefinitions(aspectDef).then(() => {
                self.getAspects();
            });
        };

        this.saveQuestion = (question) => {
            question = {...question};
            question.aspectId = self.currentAspect.id;
            if(question.id) {
                heuristicsService.updateQuestion(question).then((resQuesion) => {
                    self.currentAspect.questions = self.currentAspect.questions.map(currentQuestion => {
                        return currentQuestion.id === resQuesion.id ? resQuesion : currentQuestion;
                    });
                });
            } else {
                self.currentAspect.questions.pop();
                question.type = false;
                heuristicsService.createQuestion(question).then((resQuestion) => {
                    self.currentAspect.questions.push(resQuestion);
                });
            }
        };

        this.saveHeuristic = (heuristic) => {
            if (heuristic.aspect) {
                heuristic.learningAspect = heuristic.aspect;
            }
            heuristicsService.updateHeuristic(heuristic).then(() => {
                self.getAspects();
                self.newheuristic.value = '';
            });
        };

        this.addQuestion = () => {
            if((this.currentAspect.questions.length &&
               this.currentAspect.questions[this.currentAspect.questions.length - 1].id != null) ||
               !this.currentAspect.questions.length) {
                let question = {edit: true};
                this.currentAspect.questions.push(question);
            }
        };

        this.removeQuestion = (question) => {
            heuristicsService.removeQuestion(question).then(() => {
                self.getAspects();
            });
        };

        this.removeHeuristic = (heuristic) => {
            heuristicsService.removeHeuristic(heuristic).then(() => {
                self.getAspects();
            });
        };

        this.addNewHeuristic = (heuristic) => {
            heuristic.learningAspect = self.currentAspect.name;
            self.saveHeuristic(heuristic);
        };

        this.editQuestion = (question) => {
            self.editedQuestion = {...question};
            question.edit = true;
        };

        this.cancelEditQuestion = (question) => {
            if(question.id) {
                question.edit = false;
            } else {
                this.currentAspect.questions.pop();
            }
        };

        this.addNewQuestionPrompt = () => {
            $mdDialog.show({
                clickOutsideToClose: true,
                templateUrl: 'newQuestion.tmpl.html',
                parent: angular.element(document.body),
                multiple: true,
                controller: function DialogController($scope, $mdDialog) {
                    $scope.closeDialog = function() {
                        $mdDialog.cancel();
                    };
                    $scope.save = function(result) {
                        $mdDialog.hide(result);
                    };
                }
            })
            .then(function(questionData) {
                self.saveQuestion(questionData);
            }, function() {
            });
        };

        this.getAspects();
    }
}

export default HeuristicsEditorController;


// WEBPACK FOOTER //
// ./src/app/pages/manageSkills/heuristics/heuristicsEditorController.js